import React, { useState } from "react";
import { TextField, Box, Typography } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/system";
import API from "../../../utils/api";
import { IoIosAddCircle } from "react-icons/io";
import { MdArrowBackIosNew, MdArrowForwardIos } from "react-icons/md";

import { Card as MuiCard } from "@mui/material";

const StyledTextField = styled(TextField)(({ theme }) => ({
  margin: "0 5px",
  "& .MuiInputBase-input": {
    color: "#fff",
  },
  "& .MuiInputLabel-root": {
    color: "#c770f0",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#c770f0",
    },
    "&:hover fieldset": {
      borderColor: "#c770f0",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#c770f0",
    },
  },
}));
const Card = styled(MuiCard)`
  background-color: #1b1a2ea9;
  color: white;
  box-shadow: 0 4px 5px 3px rgba(119, 53, 136, 0.459);
  transition: all 0.5s ease 0s;
  margin-top: 0.7rem;
  padding: 0.5rem;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
`;
const NewItemInput = ({ refresh, parent = "root" }) => {
  const [data, setData] = useState({
    parentId: parent,
    type: "item",
    text: "",
    link: "",
  });
  const stages = ["text", "type", "link"];
  const [stage, setStage] = useState(0);
  const addNew = () => {
    API.post("/api/learning/addTodo", data)
      .then(refresh)
      .then(() => {
        setData({
          parentId: parent,
          type: "item",
          text: "",
          link: "",
        });
        setStage(0);
      })
      .catch((e) => {
        alert("Error ", e);
      });
  };
  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };
  return (
    <Card>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        {stage > 0 && (
          <Typography>
            <MdArrowBackIosNew
              color="#a986ad"
              font-size="180%"
              onClick={() => setStage(stage - 1)}
            />
          </Typography>
        )}
        {stages[stage] === "text" && (
          <>
            <StyledTextField
              style={{ width: "100%" }}
              onChange={handleChange}
              label="Text"
              name="text"
              size="small"
              type="text"
              value={data.text}
              InputLabelProps={{
                shrink: true,
              }}
              required
            />
            {data.text && (
              <Typography>
                <MdArrowForwardIos
                  color="#a986ad"
                  font-size="180%"
                  onClick={() => {
                    if (data.type) {
                      setStage(stage + 1);
                    }
                  }}
                />
              </Typography>
            )}
          </>
        )}
        {stages[stage] === "type" && (
          <>
            <StyledTextField
              onChange={handleChange}
              style={{ width: "100%" }}
              size="small"
              label="Type"
              defaultValue={"item"}
              value={data.type}
              name="type"
              select
              InputLabelProps={{
                shrink: true,
              }}
              required
            >
              <MenuItem key="item" value="item">
                Item
              </MenuItem>
              <MenuItem key="card" value="card">
                Card
              </MenuItem>
            </StyledTextField>
            {data.type === "item" ? (
              <Typography>
                <MdArrowForwardIos
                  color="#a986ad"
                  font-size="180%"
                  onClick={() => {
                    if (data.type) {
                      setStage(stage + 1);
                    }
                  }}
                />
              </Typography>
            ) : (
              <Typography>
                <IoIosAddCircle
                  color="#a986ad"
                  font-size="250%"
                  onClick={addNew}
                />
              </Typography>
            )}
          </>
        )}
        {stages[stage] === "link" && (
          <>
            <StyledTextField
              onChange={handleChange}
              style={{ width: "100%" }}
              label="link"
              size="small"
              name="link"
              type="text"
              value={data.link}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Typography>
              <IoIosAddCircle
                color="#a986ad"
                font-size="250%"
                onClick={addNew}
              />
            </Typography>
          </>
        )}
      </Box>
    </Card>
  );
};

export default NewItemInput;
